import React, { memo } from 'react'; // Import React and memo for component optimization
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; // Could be lazy-loaded if necessary
import "slick-carousel/slick/slick-theme.css"; // Could be lazy-loaded if necessary
import './Banner.css';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import banner1 from '../../../assets/images/Banners/banner1.jpg';
import banner2 from '../../../assets/images/Banners/banner2.jpg';
import banner3 from '../../../assets/images/Banners/banner3.jpg';
import banner4 from '../../../assets/images/Banners/banner4.jpg';
import banner5 from '../../../assets/images/Banners/banner5.jpg';


// Memoized Previous Button Component
export const PreviousBtn = memo(({ className, onClick }) => {
  return (
    <div className={className} onClick={onClick}>
      <ArrowBackIosIcon />
    </div>
  );
});

// Memoized Next Button Component
export const NextBtn = memo(({ className, onClick }) => {
  return (
    <div className={className} onClick={onClick}>
      <ArrowForwardIosIcon />
    </div>
  );
});

const Banner = () => {
  // Slider settings
  const settings = {
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PreviousBtn />,
    nextArrow: <NextBtn />,
  };

  const banners = [banner1, banner2, banner3, banner4, banner5];
  return (
    <section className="h-250 sm:h-200 w-full rounded-sm shadow relative overflow-hidden">
      {/* Lazy loading images for performance */}
      <Slider {...settings}>
        {banners.map((el, i) => (
          <img
            draggable="false"
            className="h-72 sm:h-96 w-full object-cover"
            src={el}
            alt={`banner-${i}`} // Unique alt for better accessibility
            key={i}
            loading="lazy" // Lazy loading for images
          />
        ))}
      </Slider>
    </section>
  );
  
};

// Export the component
export default Banner;
